/** Browser builds never open this. Photon is pointed at the page's own WebSocket. */
export default class NodeSocketStub {
  constructor() {
    throw new Error('Node socket is unused in the browser');
  }
}
